module.exports = __webpack_public_path__ + "static/img/v78Bg-p.e3ed629.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/v78Bg-p.png
// module id = DW8+
// module chunks = 1